module.exports = __webpack_public_path__ + "assets/img/icon_speaking.7d9f5cda.png";